import React, {useState} from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Snackbar,
  Alert,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
interface Goal {
  taskName: string
  taskDescription: string
}

interface CaregiverNotesDialogProps {
  goalName: Goal[]
  setGoalName: (records: Goal[]) => void
  open: boolean
  onOpen: () => void
  onClose: () => void
  isDisabled?: boolean
}

const CaregiverNotesDialog: React.FC<CaregiverNotesDialogProps> = ({
  goalName,
  setGoalName,
  open,
  onOpen,
  onClose,
  isDisabled = false,
}) => {
  const [newGoal, setNewGoal] = useState<Goal>({
    taskName: '',
    taskDescription: '',
  })
  const [showWarning, setShowWarning] = useState(false)
  const handleAddGoal = () => {
    if (!newGoal.taskName || !newGoal.taskDescription) {
      setShowWarning(true)
      return
    }

    setGoalName([...goalName, newGoal])
    setNewGoal({
      taskName: '',
      taskDescription: '',
    })
    onClose()
  }

  const handleDeleteGoal = (index: number) => {
    const updated = goalName.filter((_, i) => i !== index)
    setGoalName(updated)
  }

  const handleInputChange = (field: keyof Goal, value: any) => {
    setNewGoal((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const handleCloseWarning = () => {
    setShowWarning(false)
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead style={{backgroundColor: '#2f3347'}}>
            <TableRow>
              <TableCell style={{color: 'white'}}>Actions</TableCell>
              <TableCell style={{color: 'white'}}>Name</TableCell>
              <TableCell style={{color: 'white'}}>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {goalName.length > 0 ? (
              goalName.map((goal, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <IconButton 
                      onClick={() => handleDeleteGoal(index)}
                      disabled={isDisabled}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell>{goal.taskName}</TableCell>
                  <TableCell>{goal.taskDescription}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={4}
                  align='center'
                  style={{fontWeight: 'bold', fontSize: '16px'}}
                >
                  No Records Added
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Button 
        variant='contained' 
        onClick={onOpen} 
        startIcon={<AddIcon />} 
        sx={{mt: 2}}
        disabled={isDisabled}
      >
        Add Goal
      </Button>

      <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
        <DialogTitle>Add Goal</DialogTitle>
        <DialogContent sx={{pt: 2}}>
          <TextField
            label='Name'
            fullWidth
            value={newGoal.taskName}
            onChange={(e) => handleInputChange('taskName', e.target.value)}
            sx={{mb: 2, mt: 1}}
          />
          <TextField
            label='Description'
            fullWidth
            value={newGoal.taskDescription}
            rows={3}
            multiline
            onChange={(e) => handleInputChange('taskDescription', e.target.value)}
            sx={{mb: 2, mt: 1}}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant='contained' onClick={handleAddGoal}>
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={showWarning}
        autoHideDuration={4000}
        onClose={handleCloseWarning}
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
      >
        <Alert onClose={handleCloseWarning} severity='warning' sx={{width: '100%'}}>
          Please fill all the fields.
        </Alert>
      </Snackbar>
    </>
  )
}

export default CaregiverNotesDialog
